import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3855799e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gradientLine D-Flex" }, null, -1))
const _hoisted_2 = {
  class: "W-100 CookiesLogo Shadow1",
  style: {"height":"7em","margin-bottom":"3.5em"}
}
const _hoisted_3 = { class: "MenuItem" }
const _hoisted_4 = {
  style: {"min-width":"100%"},
  class: "D-Flex"
}
const _hoisted_5 = {
  style: {"flex":"1","padding-left":"0.5em"},
  class: "D-flex M-Auto"
}
const _hoisted_6 = { class: "M-Auto color3 MenuVerticalText" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "M-Auto SettingDownPusher",
  style: {"flex":"auto"}
}, null, -1))
const _hoisted_8 = { class: "MenuItem SettingsButton" }
const _hoisted_9 = {
  style: {"min-width":"100%"},
  class: "D-Flex"
}
const _hoisted_10 = {
  style: {"flex":"1","padding-left":"0.5em"},
  class: "D-flex M-Auto"
}
const _hoisted_11 = { class: "M-Auto color3 MenuVerticalText" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "HideOnMobile",
  style: {"height":"0.4em"}
}, null, -1))
const _hoisted_13 = {
  class: "O-75 V-Auto color3",
  style: {"padding":"0 1em","letter-spacing":"0.3em"}
}
const _hoisted_14 = {
  class: "color3",
  style: {"font-size":"0.8em","margin":"auto 0em"}
}
const _hoisted_15 = {
  class: "D-Flex",
  href: "https://cookiesbis.com/",
  target: "_blank"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "TopNavBG" }, null, -1))
const _hoisted_18 = ["src"]
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  style: {"padding":"0.35em 0.75em"},
  class: "V-Auto HoverGlow BG2 Rad3 F-Bold Shadow2 D-Flex"
}
const _hoisted_21 = { class: "V-Auto" }
const _hoisted_22 = {
  class: "V-Auto",
  style: {"padding":"0.2em 0.5em"}
}
const _hoisted_23 = { class: "V-Auto" }
const _hoisted_24 = {
  style: {"padding":"0.35em 0.75em"},
  class: "V-Auto HoverGlow BG2 Rad3 F-Bold Shadow2 D-Flex"
}
const _hoisted_25 = { class: "V-Auto" }
const _hoisted_26 = {
  key: 0,
  class: "V-Auto"
}
const _hoisted_27 = ["ToolTip"]
const _hoisted_28 = { class: "F_85em" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "F_85em" }, ":", -1))
const _hoisted_30 = { class: "F-Bold F_85em" }
const _hoisted_31 = ["ToolTip"]
const _hoisted_32 = { class: "F_85em" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "F_85em" }, ":", -1))
const _hoisted_34 = { class: "F-Bold F_85em" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MenuButton = _resolveComponent("MenuButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.Access('Main_Navigation'))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["CookiesMenu D-Flex Shadow1 noprint", _ctx.$store.state.Printing !== '' && 'PrintingHider'])
        }, [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/'))),
              class: "Pointer",
              style: _normalizeStyle([{"height":"80%","width":"80%","background-size":"contain","background-position":"center","background-repeat":"no-repeat","margin":"10%"}, 'background-image: url(' + _ctx.DefaultImageHandler(_ctx.$store.getters.DynamicConfig.Logo, 'https://cookiesbis.com/assets/Logo.svg') + ');'])
            }, null, 4)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Items, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
              (_ctx.Access(item.Access) && !item.Down)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "MenuFullItem",
                    to: item.Link
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_CookiesIcon, {
                            IconsSheet: _ctx.Icons,
                            class: "M-Auto SQR2em",
                            ID: item.Icon
                          }, null, 8, ["IconsSheet", "ID"])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.Translate(item.Name)), 1)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          _hoisted_7,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Items, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
              (_ctx.Access(item.Access) && item.Down)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "MenuFullItem",
                    to: item.Link
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_CookiesIcon, {
                            IconsSheet: _ctx.Icons,
                            class: "M-Auto SQR2em",
                            ID: item.Icon
                          }, null, 8, ["IconsSheet", "ID"])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.Translate(item.Name)), 1)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          _hoisted_12
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$store.state.CookiesConfig.NoCopyRights ? 'D-None' : '', "CookiesCopyrights NOPRINT Shadow1"]),
      style: _normalizeStyle(_ctx.Access('Main_Navigation') ? '' : 'bottom : 0;')
    }, [
      _createElementVNode("div", _hoisted_13, "v " + _toDisplayString(_ctx.$store.state.CookiesVersion), 1),
      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.Translate('powered by')) + ": ", 1),
      _createElementVNode("a", _hoisted_15, [
        _createElementVNode("img", {
          style: {"height":"70%","margin":"auto 1em"},
          src: _ctx.$store.getters.CurrentTheme === 'light' ? require('@/assets/defaults/DarkCookies.svg') : require('@/assets/defaults/MilkCookies.svg'),
          alt: ""
        }, null, 8, _hoisted_16)
      ])
    ], 6),
    _createElementVNode("div", {
      id: "CookiesTopNav",
      class: _normalizeClass(["CookiesTopNav D-Flex color3 noprint", _ctx.$store.state.Printing !== '' && 'PrintingHider'])
    }, [
      _hoisted_17,
      _createElementVNode("div", {
        class: "M-Auto TopHeaderLogo TopHeaderTitle",
        style: _normalizeStyle([{"height":"100%","margin":"0"}, _ctx.Access('Main_Navigation') ? '' : 'display: block;'])
      }, [
        _createElementVNode("img", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/'))),
          class: "Pointer",
          style: {"height":"100%","max-width":"15vw"},
          src: _ctx.DefaultImageHandler(_ctx.$store.getters.DynamicConfig.Logo, 'https://cookiesbis.com/assets/Logo.svg')
        }, null, 8, _hoisted_18)
      ], 4),
      _createElementVNode("div", {
        style: _normalizeStyle([{"user-select":"none","-webkit-user-select":"none"}, _ctx.Access('Main_Navigation') ? '' : 'margin-left: 1em;']),
        class: "M-Auto TopHeaderTitle",
        innerHTML: _ctx.$store.getters.DynamicConfig.Name ? _ctx.$store.getters.DynamicConfig.Name.replaceAll('\n', '<br>') : ''
      }, null, 12, _hoisted_19),
      _createElementVNode("div", {
        class: "D-Flex ShowOnMobile",
        style: _normalizeStyle([{"user-select":"none !important","-webkit-user-select":"none"}, (_ctx.$store.state.UserManagment.Status || _ctx.$route.meta.LoginHeader) ? '' : 'opacity: 0; pointer-events: none; display:none'])
      }, [
        _createVNode(_component_MenuButton, {
          Res: 'TopNavToogle',
          class: "V-Auto H-100"
        })
      ], 4),
      _createElementVNode("div", null, [
        (_ctx.$store.state.UserManagment.Status)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "D-Flex H-100 TopNavMobile",
              style: _normalizeStyle(_ctx.MEMRead('TopNavToogle') ? 'top: 0;': '')
            }, [
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ChangeLanguage())),
                class: "LangSelector H-100 D-Flex F_85em",
                style: {"padding":"0em 1.5em"}
              }, [
                _createElementVNode("span", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.Languages[_ctx.$store.state.CookiesConfig.Language]?.Name), 1)
                ])
              ]),
              _createElementVNode("div", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/Settings/Account'))),
                class: "V-Auto UserImage",
                style: _normalizeStyle([{"width":"2.5em","height":"2.5em","border-radius":"10em","margin-right":"0.2em"}, 'background-image: url('+ _ctx.DefaultImageHandler(_ctx.$store.state.CookiesConfig.UserImage) + ')'])
              }, null, 4),
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$store.state.UserManagment.CurrentUser.Email), 1),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.LogOut && _ctx.LogOut(...args))),
                  style: {"height":"2.5em"},
                  class: "F-Bold CookiesButton BGRed"
                }, _toDisplayString(_ctx.Translate('Log out')), 1)
              ])
            ], 4))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "D-Flex H-100 TopNavMobile",
              style: _normalizeStyle(_ctx.MEMRead('TopNavToogle') ? 'top: 0;': '')
            }, [
              _createElementVNode("div", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.ChangeLanguage())),
                class: "LangSelector H-100 D-Flex F_85em",
                style: {"padding":"0em 1.5em"}
              }, [
                _createElementVNode("span", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.Languages[_ctx.$store.state.CookiesConfig.Language]?.Name), 1)
                ])
              ]),
              (_ctx.$route.meta.LoginHeader)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("button", {
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.LogIN && _ctx.LogIN(...args))),
                      style: {"width":"7em","height":"2.5em"},
                      class: "F-Bold CookiesButton BGMain"
                    }, _toDisplayString(_ctx.Translate('Log in')), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 4))
      ]),
      (_ctx.HaveSystem('Branches'))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "Branch",
            style: _normalizeStyle('direction:' + _ctx.$store.getters.Direction)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.Access('Branches_Read') && _ctx.$store.state.BranchManagment.AvailableBranches && _ctx.$store.state.BranchManagment.AvailableBranches.length > 1 ? '': 'Disabled O-75i'),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.Access('Branches_Read') && _ctx.ChangeBranch())),
              ToolTip: _ctx.Translate('Change Branch')
            }, [
              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.Translate('Branch')), 1),
              _hoisted_29,
              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$store.state.BranchManagment.BranchesMode ? _ctx.$store.state.BranchManagment.CurrentBranch?.Name : ''), 1)
            ], 10, _hoisted_27)
          ], 4))
        : _createCommentVNode("", true),
      (_ctx.HaveSystem('Branches') && _ctx.Access('Inventory_Warehouses_Edit') && _ctx.$store.state.BranchManagment.BranchesMode && _ctx.$store.state.BranchManagment.CurrentBranch?.ID === 2)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "Branch",
            style: _normalizeStyle(['direction:' + _ctx.$store.getters.Direction, {"right":"0 !important","left":"auto","margin-left":"auto","margin-right":"1em","justify-content":"right","pointer-events":"none"}])
          }, [
            _createElementVNode("div", {
              style: {"pointer-events":"all","border-radius":"0 0 0.5em 0.5em","padding":"0.2em 0.5em"},
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.ChangeWarehouse())),
              ToolTip: _ctx.Translate('Change Warehouse')
            }, [
              _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.Translate('Warehouse')), 1),
              _hoisted_33,
              _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$store.state.CookiesMemory.CurrentWarehouse?.Name), 1)
            ], 8, _hoisted_31)
          ], 4))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}